<template>
    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container">
            <header class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content content--header">
                        <section class="content-header">
                            <h1>{{labels.redenContact.kop}}</h1>
                            <p>{{labels.redenContact.stapIndicator}}</p>
                        </section>
                    </div>
                </div>
            </header>
            <article>
                <div class="row">
                    <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                        <div class="content-background">
                            <div class="content">
                                <form>
                                    <fieldset class="input">

                                        <legend class="">{{labels.redenContact.subkop}}</legend>
                                        <label class="input__hint">{{labels.redenContact.keuzelijstLabel}}</label>
                                        <div v-for="reden of contactredenen" v-bind:key="reden.name"
                                             class="input__group input__group--radio">
                                            <input type="radio" name="optradio" :id="reden.name"
                                                   class="input__control input__control--radio" 
                                                   v-bind:value="reden.name" v-model="keuzemodel">
                                            <label class="input__label input__label--radio" :for="reden.name">{{reden.label}}</label>
                                        </div>
                                    </fieldset>
                                </form>
                                <p>

                                    <button v-bind:class="[btnClass, {'btn--disabled ': v$.$invalid}]" @click="gaVerder">
                                        {{labels.algemeen.button}}
                                    </button>
                                    {{labels.algemeen.of}}
                                    <router-link :to="{name: 'home'}">{{labels.algemeen.labelVorige}}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </main>
</template>

<script>
    import { useVuelidate } from '@vuelidate/core'
    import { required } from '@vuelidate/validators'
    import {mapGetters} from 'vuex';

    export default {
        name: "redenContact",
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        data() {
            return {
                keuze: undefined,
                btnClass: 'btn btn--primary'
            }
        },
        methods: {
            gaVerder() {
                this.v$.$touch();
                if(!this.v$.$invalid) {
                    this.$router.push({name: 'vraag'});
                }
            }
        },
        computed: {
            ...mapGetters(['contactredenen', 'labels']),
            keuzemodel: {
                set(x) {
                    this.$store.commit('setReden', x)
                },
                get() {
                    return this.$store.state.form.redenContact
                }
            }
        },
        created() {
            this.$trackPageView('Reden contact');              
        },
        validations: {
            keuzemodel: {
                required
            }
        }
    }
</script>

<style scoped>

</style>
